export default {
  title: 'NUTRITION SETTINGS',
};
